import { ReactElement } from 'react'
import { noOperations } from 'helpers'
import { ModalFooterProps } from './typing'
import { Container, PrimaryButton, SecondaryButton } from './subcomponents'

const ModalFooter = ({
  primaryButtonText = 'Submit',
  primaryButtonIcon = null,
  onPrimaryButtonClick = noOperations,
  isPrimaryEnabled = true,
  primaryStyles = {},
  secondaryButtonText,
  onSecondaryButtonClick,
  secondaryStyles = {},
  showOnlySecondaryButton = false,
  primaryButtonRef,
  className,
  ...props
}: ModalFooterProps): ReactElement => {
  return (
    <Container className={className} data-test={props['data-test']}>
      <SecondaryButton
        type="button"
        buttonType="secondary"
        onClick={onSecondaryButtonClick}
        $show={showOnlySecondaryButton}
        $styles={secondaryStyles}
      >
        {secondaryButtonText}
      </SecondaryButton>
      {!showOnlySecondaryButton && (
        <PrimaryButton
          ref={primaryButtonRef}
          type="button"
          buttonType="primary"
          onClick={onPrimaryButtonClick}
          isDisabled={!isPrimaryEnabled}
          $styles={primaryStyles}
        >
          {primaryButtonIcon}
          {primaryButtonText}
        </PrimaryButton>
      )}
    </Container>
  )
}

export default ModalFooter
